import type { SVGProps } from 'react';

const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={20}
    viewBox='0 0 20 20'
    width={20}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M16.442 4.442a.625.625 0 1 0-.884-.884L10 9.116 4.442 3.558a.625.625 0 1 0-.884.884L9.116 10l-5.558 5.558a.625.625 0 1 0 .884.884L10 10.884l5.558 5.558a.625.625 0 1 0 .884-.884L10.884 10z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgClose;
